export const formatVehicleListingExternalId = (
  vehicleListingExternalId = '',
) => {
  const parts = vehicleListingExternalId
    ? vehicleListingExternalId.split('-')
    : [];

  if (parts.length <= 1) {
    return vehicleListingExternalId || '';
  }

  parts.shift();
  return parts.join('-');
};

export const getNormalisedLead = lead => {
  const defaultLead = {
    billingState: '',
    createdAt: '',
    id: '95201cba-f1d7-4915-b826-451fa2e4a6b1',
    lastUpdatedAt: '',
    price: 0,
    saleState: 'OPEN',
    leadCategory: 'OPEN',
    lead: {
      id: '',
      createdAt: '',
      message: '',
      state: 'INHOUSE_TEST',
      type: '',
      vehicleListingDealerId: '',
      vehicleListingExternalId: '',
      vehicleListingId: '',
      vehicleListing: {
        createdAt: '',
        categories: [],
        dealer: {
          id: '',
          name: '',
        },
        externalId: '',
        id: '',
        images: [],
        make: {
          displayName: '',
          id: '',
        },
        model: {
          displayName: '',
          id: '',
          make: '',
          source: '',
        },
        noOfFavourites: 0,
        noOfLeadsChat: 0,
        noOfLeadsEmail: 0,
        noOfLeadsPhone: 0,
        noOfViews: 0,
        price: 0,
        state: 'NONE',
      },
      agent: {
        email: '',
        fullName: '',
        id: '',
        phone: '',
      },
      customer: {
        email: '',
        fullName: '',
        id: '',
        phone: '',
      },
      dealer: {
        email: '',
        fullName: '',
        id: '',
        phone: '',
      },
    },
    reportedAt: '',
  };

  return {
    ...defaultLead,
    ...lead,
  };
};
